import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { TableIcon } from '@phosphor-icons/react';
import {
  Route as pathlessAuthenticatedRoute,
  requireAnyPermission,
  requireModules,
} from '../../route';
import { PricingMasterlistPage } from './PricingMasterlistPage';

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/pricing/masterlist',
  staticData: {
    app: {
      nav: {
        label: msg('PCSC Masterlist', {
          context: 'sidebar nav label, Pricing section',
        }),
        icon: <TableIcon className="h-4 w-4" weight="fill" />,
        group: 'Pricing',
        order: 40,
        groupOrder: 35,
      },
      access: {
        modulesAnyOf: [ProductModule.PRICING],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Pricing }],
      },
    },
  },
  component: PricingMasterlistPage,
  loader: () => ({
    crumb: msg('PCSC Masterlist', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.PRICING],
    });
    // The `access` metadata above only decides what the sidebar shows. Direct
    // navigation needs its own guard, or a module-enabled user without Pricing
    // read reaches the page and reads an authorization failure as "nothing is
    // loaded yet".
    await requireAnyPermission({
      context,
      permissions: [{ action: Action.Read, subject: Subject.Pricing }],
    });
  },
});
